
import type { TestelopeUserState, TestelopeUserDispatch } from "./TestelopeUserTypes";

export const TestelopUserReducer = (state: TestelopeUserState, action: TestelopeUserDispatch) => {
  switch (action.type) {
    case 'TESTELOPE_USER':
      return {
        ...state,
        testelopeUser: action.value.testelopeUser,
      };
    default:
      return state;
  }
};